/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/

import { Button, withStyles } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { SearchModal, useSearchModal } from '@backstage/plugin-search';
import { SearchContextProvider } from '@backstage/plugin-search-react';

const SearchBtnStyled = withStyles(theme => ({
  root: {
    backgroundColor: '#FFFFFF',
    borderRadius: '40px',
    width: '280px',
    justifyContent: 'space-between',
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    color: theme.palette.text.secondary,
    '&:hover': {
      backgroundColor: '#FFFFFF',
      color: theme.palette.text.primary,
    },
  },
}))(Button);

export const SearchBtn = () => {
  const { state, toggleModal } = useSearchModal();

  return (
    <>
      <SearchBtnStyled endIcon={<SearchIcon />} onClick={toggleModal}>
        Search Catalog
      </SearchBtnStyled>
      {state.open && !state.hidden && (
        <SearchContextProvider initialState={{ term: ' ', types: [], filters: {} }}>
          <SearchModal {...state} toggleModal={toggleModal} />
        </SearchContextProvider>
      )}
      {(state.hidden || !state.open) && <SearchModal {...state} toggleModal={toggleModal} />}
    </>
  );
};
